module.exports = __webpack_public_path__ + "img/5.27dccaa6.png";